import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/img/HKfoto2.png'


const _hoisted_1 = { class: "bg-hk-cream section-decorated" }
const _hoisted_2 = { class: "container mx-auto px-4 py-16 md:py-20 relative z-10" }
const _hoisted_3 = { class: "grid md:grid-cols-5 gap-8 items-center" }
const _hoisted_4 = { class: "md:col-span-3" }
const _hoisted_5 = { class: "text-xl sm:text-2xl md:text-3xl text-hk-dark mb-2" }
const _hoisted_6 = { class: "text-xl sm:text-2xl md:text-3xl text-hk-dark leading-relaxed" }
const _hoisted_7 = { class: "text-base sm:text-lg md:text-xl text-hk-dark leading-relaxed mt-5" }
const _hoisted_8 = { class: "text-base sm:text-lg md:text-xl text-hk-dark leading-relaxed mt-1" }
const _hoisted_9 = { class: "text-base sm:text-lg md:text-xl font-semibold text-hk-red mt-1" }
const _hoisted_10 = {
  href: "#simuleer",
  class: "inline-block mt-8 bg-hk-red text-white btn-modern"
}
const _hoisted_11 = { class: "bg-white section-decorated" }
const _hoisted_12 = { class: "container mx-auto px-4 py-16 max-w-4xl relative z-10" }
const _hoisted_13 = { class: "font-serif text-2xl md:text-3xl font-bold text-hk-dark mb-2" }
const _hoisted_14 = { class: "space-y-3 text-base text-hk-dark leading-relaxed mb-10" }
const _hoisted_15 = { class: "text-xl md:text-2xl font-bold text-hk-red mb-8" }
const _hoisted_16 = { class: "grid sm:grid-cols-2 gap-6 mb-10" }
const _hoisted_17 = { class: "font-bold text-hk-dark mb-1" }
const _hoisted_18 = { class: "text-sm text-hk-gray leading-relaxed" }
const _hoisted_19 = { class: "bg-hk-cream-dark rounded-2xl p-8 space-y-3 text-base text-hk-dark leading-relaxed" }
const _hoisted_20 = { class: "font-bold text-lg" }
const _hoisted_21 = { class: "font-semibold text-hk-red" }
const _hoisted_22 = {
  id: "simuleer",
  class: "bg-hk-cream-dark section-decorated"
}
const _hoisted_23 = { class: "container mx-auto px-4 py-16 relative z-10" }
const _hoisted_24 = { class: "text-center mb-12" }
const _hoisted_25 = { class: "font-serif text-2xl md:text-3xl font-bold text-hk-dark uppercase tracking-wide" }
const _hoisted_26 = { class: "text-hk-gray mt-4" }
const _hoisted_27 = { class: "text-sm text-hk-red font-semibold mt-2" }
const _hoisted_28 = { class: "grid md:grid-cols-2 gap-10" }
const _hoisted_29 = { class: "text-base text-hk-dark leading-relaxed" }
const _hoisted_30 = { class: "card-modern p-6" }
const _hoisted_31 = { class: "flex rounded-full overflow-hidden border border-hk-cream-dark mb-6" }
const _hoisted_32 = { class: "space-y-4" }
const _hoisted_33 = { class: "flex items-center gap-1 text-sm font-medium text-hk-gray mb-1" }
const _hoisted_34 = { class: "flex items-center gap-2" }
const _hoisted_35 = {
  key: 0,
  class: "text-xs text-hk-red mt-1"
}
const _hoisted_36 = { class: "flex items-center gap-1 text-sm font-medium text-hk-gray mb-1" }
const _hoisted_37 = { class: "flex items-center gap-2" }
const _hoisted_38 = { class: "flex items-center gap-1 text-sm font-medium text-hk-gray mb-1" }
const _hoisted_39 = {
  key: 0,
  class: "pt-2 border-t space-y-2"
}
const _hoisted_40 = { class: "flex justify-between items-center" }
const _hoisted_41 = { class: "text-sm text-hk-gray" }
const _hoisted_42 = { class: "text-base font-semibold text-hk-dark" }
const _hoisted_43 = { class: "flex justify-between items-center" }
const _hoisted_44 = { class: "text-sm text-hk-gray" }
const _hoisted_45 = { class: "text-base font-semibold text-hk-dark" }
const _hoisted_46 = { class: "flex justify-between items-center pt-2 border-t" }
const _hoisted_47 = { class: "text-base text-hk-gray" }
const _hoisted_48 = { class: "text-2xl font-bold text-hk-red" }
const _hoisted_49 = {
  key: 1,
  class: "pt-2 border-t"
}
const _hoisted_50 = { class: "text-sm text-hk-gray text-center py-3" }
const _hoisted_51 = { class: "text-xs text-hk-gray text-center mt-2" }
const _hoisted_52 = { class: "bg-hk-cream section-decorated" }
const _hoisted_53 = { class: "container mx-auto px-4 pt-20 md:pt-28 pb-24 md:pb-32 relative z-10" }
const _hoisted_54 = { class: "grid md:grid-cols-2 gap-10 items-center" }
const _hoisted_55 = { class: "font-serif text-2xl md:text-3xl text-hk-dark mb-2" }
const _hoisted_56 = ["placeholder"]
const _hoisted_57 = ["placeholder"]
const _hoisted_58 = ["placeholder"]
const _hoisted_59 = ["placeholder"]
const _hoisted_60 = {
  key: 0,
  class: "text-green-600 font-semibold"
}
const _hoisted_61 = {
  key: 1,
  class: "text-red-600 font-semibold"
}
const _hoisted_62 = { class: "pt-2" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { class: "flex flex-col items-center justify-center text-center" }
const _hoisted_65 = { class: "card-modern p-8 max-w-sm" }
const _hoisted_66 = { class: "font-serif text-xl font-semibold text-hk-red mb-4" }
const _hoisted_67 = { class: "text-base text-hk-dark leading-relaxed" }
const _hoisted_68 = { class: "relative bg-white border border-hk-red/30 rounded-2xl p-6 max-w-sm w-full shadow-xl" }
const _hoisted_69 = {
  key: 0,
  class: "text-sm text-hk-red leading-relaxed"
}
const _hoisted_70 = {
  key: 1,
  class: "text-sm text-hk-red leading-relaxed"
}
const _hoisted_71 = { key: 2 }
const _hoisted_72 = { class: "text-sm text-hk-red leading-relaxed mb-3" }
const _hoisted_73 = {
  key: 0,
  class: "w-full text-sm text-hk-red border-collapse"
}
const _hoisted_74 = { class: "border-b border-hk-red/20" }
const _hoisted_75 = { class: "text-left py-1.5 text-hk-red font-semibold" }
const _hoisted_76 = { class: "text-right py-1.5 text-hk-red font-semibold" }
const _hoisted_77 = { class: "py-1.5" }
const _hoisted_78 = { class: "text-right py-1.5" }

import { ref, reactive, computed, watch } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "@/i18n";
import CustomSelect from "@/components/CustomSelect.vue";

const FORMSUBMIT_URL = "https://formsubmit.co/ajax/hasweb@haskrediet.be";

type SimType = 'woon' | 'loa';

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();
const brokerFeatures = ['ervaring', 'persoonlijk', 'onafhankelijk', 'begeleiding', 'vertrouwen', 'aanbod'];

const showAmountInfo = ref(false);
const showRateInfo = ref(false);
const showDurationInfo = ref(false);
const closePopups = () => { showAmountInfo.value = false; showRateInfo.value = false; showDurationInfo.value = false; };

const durationTable = computed(() => {
  const rows = [
    { max: 2500, months: 24 },
    { max: 3700, months: 30 },
    { max: 5600, months: 36 },
    { max: 7500, months: 42 },
    { max: 10000, months: 48 },
    { max: 15000, months: 60 },
    { max: 20000, months: 84 },
    { max: 37000, months: 120 },
  ];
  return [
    ...rows.map((r, i) => {
      const min = i === 0 ? 500 : rows[i - 1].max + 0.01;
      return { label: `${formatCurrency(min)} - ${formatCurrency(r.max)}`, duration: formatDuration(r.months) };
    }),
    { label: `${formatCurrency(37000.01)} - ${formatCurrency(99999.99)}`, duration: formatDuration(180) },
  ];
});

const simType = ref<SimType>('woon');
const simAmount = ref(150000);
const simRate = ref(0);
const simDuration = ref(240);

const loaMaxMonths = (amount: number): number => {
  if (amount <= 2500) return 24;
  if (amount <= 3700) return 30;
  if (amount <= 5600) return 36;
  if (amount <= 7500) return 42;
  if (amount <= 10000) return 48;
  if (amount <= 15000) return 60;
  if (amount <= 20000) return 84;
  if (amount <= 37000) return 120;
  return 180;
};

const formatDuration = (months: number) => {
  const years = months / 12;
  if (years < 1) return `${months} ${t('loan.months')}`;
  const formatted = years % 1 === 0 ? `${years}` : `${years.toFixed(1).replace('.', ',')}`;
  return `${formatted} ${t('woon.sim.years')} (${months} ${t('loan.months')})`;
};

const loaDurations = computed(() => {
  const max = loaMaxMonths(simAmount.value);
  const all = [12, 18, 24, 30, 36, 42, 48, 60, 84, 120, 180];
  return all.filter(m => m <= max).map(m => ({ value: m, label: formatDuration(m) }));
});

const woonDurations = [5, 10, 15, 20, 25, 30].map(y => ({
  value: y * 12,
  get label() { return `${y} ${t('woon.sim.years')} (${y * 12} ${t('loan.months')})`; }
}));

const simConfig = computed(() => {
  if (simType.value === 'woon') {
    return {
      minAmount: 25000, maxAmount: 3000000, amountStep: 5000,
      durations: woonDurations,
    };
  }
  return {
    minAmount: 500, maxAmount: 99999.99, amountStep: 100,
    durations: loaDurations.value,
  };
});

const setSimType = (type: SimType) => {
  simType.value = type;
  if (type === 'woon') {
    simAmount.value = 150000;
    simRate.value = 0;
    simDuration.value = 240;
  } else {
    simAmount.value = 8000;
    simRate.value = 0;
    simDuration.value = 48;
  }
  amountDisplay.value = formatNum(simAmount.value);
};

const amountWarning = ref('');
let warningTimer: ReturnType<typeof setTimeout>;

watch(simAmount, (amt) => {
  const max = simConfig.value.maxAmount;
  if (amt > max) {
    simAmount.value = max;
    amountDisplay.value = formatNum(max);
    amountWarning.value = t('loan.maxAmount', { max: formatCurrency(max) });
    clearTimeout(warningTimer);
    warningTimer = setTimeout(() => { amountWarning.value = ''; }, 3000);
    return;
  }
  if (simType.value === 'loa') {
    const maxMonths = loaMaxMonths(amt);
    if (simDuration.value > maxMonths) simDuration.value = maxMonths;
  }
});

const rateChosen = computed(() => simRate.value > 0);

const monthlyPayment = computed(() => {
  const rate = simRate.value / 100 / 12;
  const n = simDuration.value;
  const pv = simAmount.value;
  if (rate === 0) return pv / n;
  return (pv * rate * Math.pow(1 + rate, n)) / (Math.pow(1 + rate, n) - 1);
});

const totalRepay = computed(() => monthlyPayment.value * simDuration.value);
const totalInterest = computed(() => totalRepay.value - simAmount.value);

const formatCurrency = (value: number) => {
  return new Intl.NumberFormat("nl-BE", { style: "currency", currency: "EUR" }).format(value);
};

const formatNum = (n: number) => n > 0 ? new Intl.NumberFormat('nl-BE', { maximumFractionDigits: 0 }).format(n) : '';
const amountDisplay = ref(formatNum(simAmount.value));

watch(amountDisplay, (val) => {
  const num = parseInt(val.replace(/\./g, ''), 10);
  if (!isNaN(num) && num >= 0) simAmount.value = num;
});

const onAmountBlur = () => {
  amountDisplay.value = formatNum(simAmount.value);
};

const goToContactWithSim = () => {
  const typeLabel = simType.value === 'woon' ? t('sim.type.woon') : t('sim.type.loa');
  const msg = `${typeLabel}\n${t('loan.amount')}: ${formatCurrency(simAmount.value)}\n${t('loan.rate')}: ${simRate.value}%\n${t('loan.duration')}: ${simDuration.value} ${t('loan.months')}\n${t('loan.monthly')}: ${formatCurrency(monthlyPayment.value)}`;
  router.push({ name: "contact", query: { message: msg } });
};

const contactSubmitting = ref(false);
const contactStatus = ref<"" | "success" | "error">("");
const contactForm = reactive({
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
});

const submitContact = async () => {
  contactSubmitting.value = true;
  contactStatus.value = "";
  try {
    const res = await fetch(FORMSUBMIT_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        _subject: "Nieuw contact via homepage - Haskrediet",
        Voornaam: contactForm.firstName,
        Naam: contactForm.lastName,
        Email: contactForm.email,
        Telefoon: contactForm.phone,
        _template: "table",
      }),
    });
    if (!res.ok) throw new Error();
    contactStatus.value = "success";
    contactForm.firstName = "";
    contactForm.lastName = "";
    contactForm.email = "";
    contactForm.phone = "";
  } catch {
    contactStatus.value = "error";
  } finally {
    contactSubmitting.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('home.hero.title')), 1),
            _createElementVNode("p", _hoisted_6, [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "font-bold text-hk-red" }, "Haskrediet", -1)),
              _createTextVNode(" " + _toDisplayString(_unref(t)('home.hero.body')), 1)
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)('home.hero.sub1')), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)('home.hero.sub1b')), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('home.hero.sub2')), 1),
            _createElementVNode("a", _hoisted_10, _toDisplayString(_unref(t)('footer.simuleer')), 1)
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "md:col-span-2 flex justify-center" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "HasKrediet",
              class: "max-w-full h-auto rounded-2xl shadow-xl"
            })
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("h2", _hoisted_13, _toDisplayString(_unref(t)('home.broker.title')), 1),
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "w-16 h-1 bg-hk-red rounded-full mb-8" }, null, -1)),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("p", null, _toDisplayString(_unref(t)('home.broker.intro1')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(t)('home.broker.intro2')), 1)
        ]),
        _createElementVNode("h3", _hoisted_15, _toDisplayString(_unref(t)('home.broker.troeven')), 1),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(brokerFeatures, (item) => {
            return _createElementVNode("div", {
              key: item,
              class: "bg-hk-cream-light rounded-xl p-5 border border-hk-cream-dark/30"
            }, [
              _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(t)(`home.broker.${item}.title`)), 1),
              _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(t)(`home.broker.${item}.text`)), 1)
            ])
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(t)('home.broker.closing.title')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(t)('home.broker.closing.text')), 1),
          _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(t)('home.broker.closing.tagline')), 1)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("h2", _hoisted_25, _toDisplayString(_unref(t)('home.sim.title')), 1),
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "w-16 h-1 bg-hk-red rounded-full mx-auto mt-3" }, null, -1)),
          _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(t)('home.sim.subtitle')), 1),
          _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(t)('home.sim.free')), 1)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(t)('home.sim.body')), 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("button", {
                class: _normalizeClass([
                  'flex-1 py-2.5 text-sm font-bold uppercase tracking-wide transition-colors',
                  simType.value === 'woon' ? 'bg-hk-red text-white' : 'bg-white text-hk-dark hover:bg-hk-cream'
                ]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (setSimType('woon')))
              }, _toDisplayString(_unref(t)('sim.type.woon')), 3),
              _createElementVNode("button", {
                class: _normalizeClass([
                  'flex-1 py-2.5 text-sm font-bold uppercase tracking-wide transition-colors',
                  simType.value === 'loa' ? 'bg-hk-red text-white' : 'bg-white text-hk-dark hover:bg-hk-cream'
                ]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (setSimType('loa')))
              }, _toDisplayString(_unref(t)('sim.type.loa')), 3)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_33, [
                  _createTextVNode(_toDisplayString(_unref(t)('loan.amount')) + " ", 1),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showAmountInfo.value = !showAmountInfo.value), ["stop"])),
                    class: "group/info text-hk-red transition-colors"
                  }, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("span", { class: "w-4 h-4 inline-flex items-center justify-center rounded-full border border-current text-xs leading-none transition-colors group-hover/info:bg-hk-red group-hover/info:text-white group-hover/info:border-hk-red" }, "i", -1)
                  ]))])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-base text-hk-gray" }, "€", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    inputmode: "numeric",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((amountDisplay).value = $event)),
                    onBlur: onAmountBlur,
                    class: "w-full rounded border-gray-300 text-base focus:ring-hk-red focus:border-hk-red"
                  }, null, 544), [
                    [_vModelText, amountDisplay.value]
                  ])
                ]),
                (amountWarning.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(amountWarning.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_36, [
                  _createTextVNode(_toDisplayString(_unref(t)('loan.rate')) + " ", 1),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (showRateInfo.value = !showRateInfo.value), ["stop"])),
                    class: "group/info text-hk-red transition-colors"
                  }, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("span", { class: "w-4 h-4 inline-flex items-center justify-center rounded-full border border-current text-xs leading-none transition-colors group-hover/info:bg-hk-red group-hover/info:text-white group-hover/info:border-hk-red" }, "i", -1)
                  ]))])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((simRate).value = $event)),
                    min: 0,
                    max: 25,
                    step: 0.01,
                    class: "w-full rounded border-gray-300 text-base focus:ring-hk-red focus:border-hk-red"
                  }, null, 512), [
                    [
                      _vModelText,
                      simRate.value,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-base text-hk-gray" }, "%", -1))
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_38, [
                  _createTextVNode(_toDisplayString(_unref(t)('loan.duration')) + " ", 1),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (showDurationInfo.value = !showDurationInfo.value), ["stop"])),
                    class: "group/info text-hk-red transition-colors"
                  }, [...(_cache[20] || (_cache[20] = [
                    _createElementVNode("span", { class: "w-4 h-4 inline-flex items-center justify-center rounded-full border border-current text-xs leading-none transition-colors group-hover/info:bg-hk-red group-hover/info:text-white group-hover/info:border-hk-red" }, "i", -1)
                  ]))])
                ]),
                _createVNode(CustomSelect, {
                  modelValue: simDuration.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((simDuration).value = $event)),
                  options: simConfig.value.durations
                }, null, 8, ["modelValue", "options"])
              ]),
              (rateChosen.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(t)('loan.totalRepay')), 1),
                      _createElementVNode("span", _hoisted_42, _toDisplayString(formatCurrency(totalRepay.value)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("span", _hoisted_44, _toDisplayString(_unref(t)('loan.totalInterest')), 1),
                      _createElementVNode("span", _hoisted_45, _toDisplayString(formatCurrency(totalInterest.value)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(t)('loan.monthly')), 1),
                      _createElementVNode("span", _hoisted_48, _toDisplayString(formatCurrency(monthlyPayment.value)), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _createElementVNode("p", _hoisted_50, _toDisplayString(_unref(t)('loan.chooseRateHint')), 1)
                  ])),
              _createElementVNode("button", {
                onClick: goToContactWithSim,
                class: "w-full bg-hk-red text-white btn-modern py-3"
              }, _toDisplayString(_unref(t)('loan.apply')), 1),
              _createElementVNode("p", _hoisted_51, _toDisplayString(_unref(t)('loan.disclaimer')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_52, [
      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "wave-divider -top-px" }, [
        _createElementVNode("svg", {
          viewBox: "0 0 1440 50",
          preserveAspectRatio: "none",
          class: "w-full h-6 md:h-10"
        }, [
          _createElementVNode("path", {
            d: "M0,50 C480,0 960,40 1440,10 L1440,0 L0,0 Z",
            fill: "#EDE5D8"
          })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", _hoisted_55, _toDisplayString(_unref(t)('contact.title')), 1),
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "w-16 h-1 bg-hk-red rounded-full mb-8" }, null, -1)),
            _createElementVNode("form", {
              class: "space-y-5",
              onSubmit: _withModifiers(submitContact, ["prevent"])
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((contactForm.firstName) = $event)),
                placeholder: _unref(t)('contact.firstName'),
                required: "",
                class: "w-full bg-white border border-hk-cream-dark/40 rounded-xl px-4 py-3 text-base placeholder:text-hk-gray-light focus:border-hk-red focus:ring-1 focus:ring-hk-red/20"
              }, null, 8, _hoisted_56), [
                [_vModelText, contactForm.firstName]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((contactForm.lastName) = $event)),
                placeholder: _unref(t)('contact.lastName'),
                required: "",
                class: "w-full bg-white border border-hk-cream-dark/40 rounded-xl px-4 py-3 text-base placeholder:text-hk-gray-light focus:border-hk-red focus:ring-1 focus:ring-hk-red/20"
              }, null, 8, _hoisted_57), [
                [_vModelText, contactForm.lastName]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((contactForm.email) = $event)),
                placeholder: _unref(t)('contact.email'),
                required: "",
                class: "w-full bg-white border border-hk-cream-dark/40 rounded-xl px-4 py-3 text-base placeholder:text-hk-gray-light focus:border-hk-red focus:ring-1 focus:ring-hk-red/20"
              }, null, 8, _hoisted_58), [
                [_vModelText, contactForm.email]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "tel",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((contactForm.phone) = $event)),
                placeholder: _unref(t)('contact.phone'),
                class: "w-full bg-white border border-hk-cream-dark/40 rounded-xl px-4 py-3 text-base placeholder:text-hk-gray-light focus:border-hk-red focus:ring-1 focus:ring-hk-red/20"
              }, null, 8, _hoisted_59), [
                [_vModelText, contactForm.phone]
              ]),
              (contactStatus.value === 'success')
                ? (_openBlock(), _createElementBlock("p", _hoisted_60, _toDisplayString(_unref(t)('contact.success')), 1))
                : _createCommentVNode("", true),
              (contactStatus.value === 'error')
                ? (_openBlock(), _createElementBlock("p", _hoisted_61, _toDisplayString(_unref(t)('contact.error')), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("button", {
                  type: "submit",
                  disabled: contactSubmitting.value,
                  class: "bg-hk-red text-white btn-modern disabled:opacity-50"
                }, _toDisplayString(contactSubmitting.value ? '...' : _unref(t)('contact.send')), 9, _hoisted_63)
              ])
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("h3", _hoisted_66, _toDisplayString(_unref(t)('contact.bubble')), 1),
              _createElementVNode("p", _hoisted_67, _toDisplayString(_unref(t)('contact.bubbleText')), 1)
            ])
          ])
        ])
      ])
    ]),
    (showAmountInfo.value || showRateInfo.value || showDurationInfo.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-50 flex items-center justify-center px-4",
          onClick: _withModifiers(closePopups, ["self"])
        }, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/30",
            onClick: closePopups
          }),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("button", {
              onClick: closePopups,
              class: "absolute top-3 right-3 text-hk-gray hover:text-hk-red transition-colors"
            }, [...(_cache[23] || (_cache[23] = [
              _createElementVNode("svg", {
                class: "w-5 h-5",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ]))]),
            (showAmountInfo.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_69, _toDisplayString(_unref(t)(`loan.amountInfo.${simType.value}`)), 1))
              : _createCommentVNode("", true),
            (showRateInfo.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_70, _toDisplayString(_unref(t)('loan.rateInfo')), 1))
              : _createCommentVNode("", true),
            (showDurationInfo.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                  _createElementVNode("p", _hoisted_72, _toDisplayString(_unref(t)(`loan.durationInfo.${simType.value}`)), 1),
                  (simType.value === 'loa')
                    ? (_openBlock(), _createElementBlock("table", _hoisted_73, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", _hoisted_74, [
                            _createElementVNode("th", _hoisted_75, _toDisplayString(_unref(t)('loan.durationTable.amount')), 1),
                            _createElementVNode("th", _hoisted_76, _toDisplayString(_unref(t)('loan.durationTable.maxDuration')), 1)
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(durationTable.value, (row) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: row.max,
                              class: "border-b border-hk-cream-dark/30"
                            }, [
                              _createElementVNode("td", _hoisted_77, _toDisplayString(row.label), 1),
                              _createElementVNode("td", _hoisted_78, _toDisplayString(row.duration), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})